module.exports = __webpack_public_path__ + "img/21.b6ae0abf.png";